// Accès à l'écran « Vue d'ensemble » (tableau de bord patrimonial, rollout progressif).
//
// FAIL-CLOSED : par défaut PERSONNE n'y a accès. Seuls les e-mails de la liste blanche
// ci-dessous voient l'entrée de menu et peuvent ouvrir l'écran. Un utilisateur sans e-mail
// lisible, ou hors liste, est traité comme non autorisé (aucun accès).
//
// Ce garde-fou protège les 1 840 clients : l'écran est déployé mais reste invisible et
// inaccessible pour tout le monde sauf la liste blanche, le temps de le valider en conditions
// réelles. Élargir l'audience = ajouter des e-mails ici + redéployer (playbook EDL/Firma).
//
// Rollout : Charly + testeurs internes (Janani, Axel). E-mails en minuscules
// (la comparaison se fait sur l'e-mail Keycloak minuscule). Voir docs/CADRAGE_VUE_ENSEMBLE_DASHBOARD.md.
const OVERVIEW_ALLOWLIST = [
  'charly.leggeri@limeare.com',
  'janani@horiz.io',
  'axel@horiz.io',
]

// E-mail de connexion (Keycloak), en minuscules. '' si non lisible -> non autorisé.
function getCurrentEmail() {
  const tp = (typeof window !== 'undefined' && window.keycloak && window.keycloak.tokenParsed) || null
  if (!tp) return ''

  return (tp.email || (tp.rl_profile && tp.rl_profile.username) || '').trim().toLowerCase()
}

export function isOverviewEnabled() {
  const email = getCurrentEmail()

  return !!email && OVERVIEW_ALLOWLIST.includes(email)
}
